import { render, staticRenderFns } from "./customerIcon.vue?vue&type=template&id=7db76957&scoped=true"
import script from "./customerIcon.vue?vue&type=script&lang=js"
export * from "./customerIcon.vue?vue&type=script&lang=js"
import style0 from "./customerIcon.vue?vue&type=style&index=0&id=7db76957&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db76957",
  null
  
)

export default component.exports